<template>
    <div id="container-card" class="h-card-small rounded-smoth overflow-hidden relative shadow-card shadow-black-12 max-md:h-44">
        <div id="img-card" class="h-full">
            <img :src="data['img']" alt="PRUEBA" class="w-full h-full blur object-cover">
        </div>
    </div>
</template>

<script setup>
import { generalStore } from '@/stores';

const store = generalStore();
const props = defineProps([
    'data'
])
</script>